<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="充值金额"
        prop="chargeValue"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.chargeValue"
          placeholder="请输入充值金额"
          @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'chargeValue')"
        />
      </el-form-item>
      <el-form-item
        label="备注"
        prop="chargeRemark"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.chargeRemark"
          placeholder="请输入备注"
          maxlength="255"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  export default {
    name: 'PartyGroupEdit',
    data() {
      return {
        form: {
          code: '',
          chargeValue: '',
          chargeRemark: '',
        },
        rules: {
          chargeValue: [
            {required: true, message: '请输入充值金额', trigger: 'blur'},
            
          ],
          chargeRemark: [
            {required: true, message: '请输入备注', trigger: 'blur'},
            
          ]
        }
      }
    },
    created() {
    },
    methods: {
      //提交
      init(code){
        this.$refs['form'].resetFields()
        this.form = {
          code: code,
          chargeValue: '',
          chargeRemark: '',
        };
      },
      funcSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            const data = this.form
            const rLoading = this.openLoading();
            request({url: '/ntocc-basic-api/partyGroup/charge', method: 'post', params: data}).then(response => {
              rLoading.close();
              this.$message({message: response.msg, type: 'success'})
              this.$emit('fatherEditMethod')
            }).then(() => this.$refs['form'].resetFields());
          } else {
            return false;
          }
        });
      },
      //取消
      funcCancel() {
        this.$emit('fatherCancelMethod', 'edit')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
